"use strict";Object.defineProperty(exports, "__esModule", {value: true});// src/common-components/lib/use-double-tap.ts
var _react = require('react');
function useDoubleTap(callback, threshold = 300) {
  const timer = _react.useRef.call(void 0, null);
  const handler = _react.useCallback.call(void 0, (e) => {
    if (timer.current) {
      e.preventDefault();
      clearTimeout(timer.current);
      callback && callback(e);
    } else {
      timer.current = setTimeout(() => {
        timer.current = null;
      }, threshold);
    }
  }, [callback, threshold]);
  return callback ? {
    onClick: handler
  } : {};
}



exports.useDoubleTap = useDoubleTap;
//# sourceMappingURL=chunk-JC36ICBW.js.map